import { number, object } from 'yup';

export const validationSchema = object().shape({
  size: object().shape({
    length: number().min(0, 'The number cannot be negative').nullable(),
    width: number().min(0, 'The number cannot be negative').nullable(),
    depth: number().min(0, 'The number cannot be negative').nullable(),
  }, ['feetOfLength', 'inchesOfLength']).nullable(),
}).nullable();
